import { Injectable } from "@angular/core";
import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";

import { OBG_VALIDATORS } from "../../../validators/validators";

import { MultiDepositLimitConfig } from "./multi-deposit-limit.config";

@Injectable()
export class MultiDepositFormValidatonService {
	forceInvalidForm = false;
	validationKey: string | undefined;

	constructor(private multiDepositLimitConfig: MultiDepositLimitConfig) {}

	getDailyValidators(
		monthlyDepositLimit: AbstractControl,
		dailyValue?: number,
		upcomingMonthly?: number,
		currentMonthly?: number
	): ValidatorFn[] {
		const dailyValidators = this.getBaseValidators(
			this.multiDepositLimitConfig.isDailyDepositLimitRequired(),
			this.multiDepositLimitConfig.getDailyDepositLimitMaxValue(),
			dailyValue
		);
		const smallerOrEqualValidator =
			currentMonthly || upcomingMonthly
				? OBG_VALIDATORS.numberSmallerOrEqual(
						() => monthlyDepositLimit.value ?? upcomingMonthly ?? currentMonthly
					)
				: OBG_VALIDATORS.numberSmallerOrEqual(() => monthlyDepositLimit.value);
		return [...dailyValidators, smallerOrEqualValidator];
	}

	getWeeklyValidators(
		monthlyDepositLimit: AbstractControl,
		weeklyValue?: number,
		upcomingMonthly?: number,
		currentMonthly?: number
	): ValidatorFn[] {
		const weeklyValidators = this.getBaseValidators(
			this.multiDepositLimitConfig.isWeeklyDepositLimitRequired(),
			this.multiDepositLimitConfig.getWeeklyDepositLimitMaxValue(),
			weeklyValue
		);
		const smallerOrEqualValidator =
			currentMonthly || upcomingMonthly
				? OBG_VALIDATORS.numberSmallerOrEqual(
						() => monthlyDepositLimit.value ?? upcomingMonthly ?? currentMonthly
					)
				: OBG_VALIDATORS.numberSmallerOrEqual(() => monthlyDepositLimit.value);
		return [...weeklyValidators, smallerOrEqualValidator];
	}

	getBaseValidators(isRequired: boolean, maxValue?: number, currentValue?: number): ValidatorFn[] {
		const standardValidators: ValidatorFn[] = [this.forceInvalidator];

		if (isRequired) {
			standardValidators.push(Validators.required, OBG_VALIDATORS.numericNotZero);
		} else {
			if (currentValue) {
				standardValidators.push(OBG_VALIDATORS.numericNotZero);
			}
		}

		if (maxValue && maxValue > 0) {
			standardValidators.push(OBG_VALIDATORS.maxValue(maxValue));
		}

		const maxLength = this.multiDepositLimitConfig.getDepositLimitsMaxLength();
		if (maxLength && maxLength > 0) {
			standardValidators.push(Validators.maxLength(maxLength));
		}
		return standardValidators;
	}

	isValueValid(value: number): boolean {
		return Number.isInteger(value) && value >= 0;
	}

	private forceInvalidator = (_control: AbstractControl): { invalidate: false } | null =>
		!this.forceInvalidForm
			? null
			: {
					invalidate: false,
				};
}
